export default __webpack_public_path__ + "261a05f4822201af82509b9daf7fcd90.svg";